import { Tooltip, TooltipProps } from "antd";
import classNames from "classnames";
import { ReactNode } from "react";
import styles from "./style.module.scss";

interface VLTooltipProps extends Omit<TooltipProps, "children"> {
  children: ReactNode;
  className?: string;
  fitContent?: boolean;
  forceHide?: boolean;
  title: ReactNode;
}

const renderTooltipTitle = (content: ReactNode) => {
  if (!content) return undefined;

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {content}
    </div>
  );
};

const VLTooltip = ({
  children,
  className,
  fitContent,
  forceHide,
  open,
  title,
  ...rest
}: VLTooltipProps) => {
  const classNameWrapper = classNames(className, {
    [styles.fitContent]: !!fitContent,
  });
  const tooltipProps: TooltipProps = {
    ...rest,
    open: forceHide ? false : open,
    ...(classNameWrapper && { overlayClassName: classNameWrapper }),
  };

  return (
    <Tooltip {...tooltipProps} title={renderTooltipTitle(title)}>
      {children}
    </Tooltip>
  );
};

export default VLTooltip;
